<div *ngIf="!chatOpened" (click)="initiateChat()">
  <div class="chat-floating-button">
    <i class="bi bi-chat-left-text"></i>
  </div>
</div>

<div class="chat-window" *ngIf="chatOpened">
  <div class="chat-header">
    <div class="save-button">
      <i class="bi bi-floppy" *ngIf="messages.length && !chatForm.disabled" (click)="closeChat()"></i>
      <i class="bi bi-x" *ngIf="chatForm.disabled || !messages.length" (click)="chatOpened = false"></i>
    </div>
    <div class="chat-title">{{ 'label.chat.title' | translate: { caseId: caseId } }}</div>
    <div class="x-close">
      <div [ngClass]="{'icon-rotate': !chatCollapsed}">
        <i class="bi bi-box-arrow-up-right" (click)="chatCollapsed = !chatCollapsed"></i>
      </div>
    </div>
  </div>
  <div class="chat-content" *ngIf="!chatCollapsed">
  <div class="all-threads-link" (click)="seeAllThreads()">{{ 'label.chat.see_all_threads' | translate }}</div>
  <div class="chat-users">
    <div class="custom-users-pill" *ngFor="let user of chatUsers?.users">
        <img [src]="'../../../../assets/img/person.png'" class="user-avatar">
        <span class="name"
          [ngClass]="{'name--removed': isUserRemoved(user.email)}">{{ user.fullName }}</span>
          @if(user.email) {
            <!-- <span class="user-email">[{{user.email}}]</span> -->
          }
        @if(!messages.length && user.email !== myUserEmail) {
          <i *ngIf="!isUserRemoved(user.email)" class="bi bi-x-lg" (click)="removeFromChat(user.email)"></i>
          <i *ngIf="isUserRemoved(user.email)" class="bi bi-arrow-counterclockwise" (click)="undoRemovedUserToChat(user.email)"></i>
        }
    </div>
  </div>
  <div class="chat-messages" #chatContainer>
    <div class="no-messages" *ngIf="!messages.length">{{ 'label.chat.no_messages' | translate }}</div>
    <div class="chat-message" *ngFor="let message of messages" [ngClass]="{'chat-message--my': isMessageMy(message)}">
      <div class="user-name">
        {{ message.user.fullName }}
      </div>
      <div class="message-content">
        <pre>{{ message.message }}</pre>
      </div>
      <div class="message-date">
        {{ helperService.adjustDateFormatToUTCByAddingZ(message.timestamp) | date: 'MMM d, y • HH:mm' }}
      </div>
    </div>
  </div>
  <form class="chat-new-message" [formGroup]="chatForm" (ngSubmit)="sendMessage()">
    <textarea *ngIf="!chatForm.disabled && isChatPossible()" class="new-message-text" formControlName="message" placeholder="{{'placeholders.chat_reply' | translate}}" (keydown)="onKeyDown($event)"></textarea>
    <div class="disabled-message" *ngIf="chatForm.disabled">
      {{ disabledMessage | translate }}
    </div>
    <div class="disabled-message" *ngIf="chatUsers.users.length > 1 && !isChatPossible()">
      {{ 'label.chat.impossible-chating' | translate }}
    </div>
    <button *ngIf="!chatForm.disabled && isChatPossible()" class="send-button" type="submit" [disabled]="!chatForm.valid">
      <i class="bi bi-send"></i>
    </button>
  </form>
  </div>
</div>
